import { sendGA } from '../utils/thirdParties';

export default function initThirdParties() {
   initJSErrorLog();
   initFullStory();
   initGA();
   // Gig.sendSeoCampaignInfo();
}

function initJSErrorLog() {
}

function initFullStory() {
   if (process.env.FS_ORG) {
      if (window.FS) {
         window.FS.identify(false);
      } else {
         // Gig.logJSError({
         //     msg: 'FullStory not initialized'
         // });
      }
   }
}

function initGA() {
   if (process.env.UA_ID) {
      sendGA('set', 'userId', null);
      setGADimensions();
      sendGA('send', 'pageview', null);
   }
}

function setGADimensions() {
   if (window.ga) {
      window.ga(function (tracker) {
         sendGA('set', 'dimension1', tracker.get('clientId'));
      });
   }
}
